// src/components/Sidebar.tsx
'use client';

import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { logout } from "../services/api";






/* Logo plano estilo Maramesa */
const MaramesaLogoFlat: React.FC<{ size?: number; color?: string; className?: string }> = ({
  size = 34,
  color = '#2F5FAA',
  className = '',
}) => (
  <div className={`w-fit ${className}`} style={{ color }}>
    <div className="flex flex-col leading-none select-none">
      <span
        className="font-black inline-block"
        style={{ fontSize: `${size}px`, transform: 'skewX(-10deg)', lineHeight: 1 }}
      >
        MARAMESA
      </span>
      <div className="flex items-center justify-between mt-1">
        <div style={{ height: 5, width: 120, backgroundColor: color, borderRadius: 2 }} />
        <span className="italic font-bold ml-3" style={{ fontSize: `${Math.round(size * 0.38)}px` }}>
          GROUP
        </span>
      </div>
    </div>
  </div>
);

type NavItem = { label: string; to: string };

const navItems: NavItem[] = [
  { label: 'Dashboard', to: '/admin' },
  { label: 'Bancos', to: '/admin/bancos' },
  { label: 'Proveedores', to: '/admin/proveedores' },
  { label: 'Órdenes de Compra', to: '/admin/odes' },
  { label: 'Gastos', to: '/admin/gastos' },
  { label: 'Reportes', to: '/admin/reportes' },
];

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [scrolled, setScrolled] = useState(false);
  const [transparent, setTransparent] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path: string) =>
    location.pathname === path ? 'text-[#EAB308]' : 'text-white/90 hover:text-[#EAB308]';
    const handleLogout = () => {
      logout();
      navigate("/login");
    };
  // Efecto scroll (gradiente → blur)
  useEffect(() => {
    let t1: ReturnType<typeof setTimeout>, t2: ReturnType<typeof setTimeout>;
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
      clearTimeout(t1);
      t1 = setTimeout(() => setTransparent(true), 800);
    };
    const onMouse = () => {
      if (window.scrollY <= 50) {
        setTransparent(false);
        clearTimeout(t2);
        t2 = setTimeout(() => setTransparent(true), 1000);
      }
    };

    window.addEventListener('scroll', onScroll);
    window.addEventListener('mousemove', onMouse);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('mousemove', onMouse);
    };
  }, []);

  // Bloquear scroll del body cuando el panel móvil está abierto
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
  }, [mobileOpen]);

  const go = (to: string) => {
    setMobileOpen(false);
    navigate(to);
  };

  // “Animación” del logo con CSS
  const logoClass = useMemo(
    () =>
      `inline-block transition-transform duration-700 will-change-transform ${
        scrolled ? 'scale-95' : 'scale-100'
      }`,
    [scrolled]
  );

  return (
    <>
      {/* NAVBAR SUPERIOR */}
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-700
          ${
            scrolled
              ? transparent
                ? 'bg-transparent'
                : 'bg-white/10 backdrop-blur-md shadow-sm'
              : 'bg-gradient-to-b from-black/60 to-transparent'
          }`}
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-3">
          {/* Logo */}
          <button onClick={() => go('/admin')} aria-label="Inicio" className={logoClass}>
            <MaramesaLogoFlat size={scrolled ? 26 : 34} />
          </button>

          {/* Menú Desktop */}
          <nav className="hidden md:flex items-center gap-6 font-semibold">
            {navItems.map((item) => (
              <button
                key={item.to}
                onClick={() => go(item.to)}
                className={`transition-colors ${isActive(item.to)}`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Toggle Mobile (SVGs en lugar de react-icons) */}
          <button
            className="md:hidden text-white p-1.5 rounded hover:bg-white/10 transition"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label={mobileOpen ? 'Cerrar menú' : 'Abrir menú'}
          >
            {mobileOpen ? (
              // Ícono "X"
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 1 0-1.41 1.41L10.59 12l-4.9 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.9a1 1 0 0 0 1.41-1.41L13.41 12l4.9-4.89a1 1 0 0 0-.01-1.4Z" />
              </svg>
            ) : (
              // Ícono "hamburguesa"
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M3 6h18a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2Zm18 5H3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2Zm0 7H3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2Z" />
              </svg>
            )}
          </button>
          <button
  onClick={handleLogout}
  className="flex items-center gap-2 rounded-lg px-3 py-2 text-slate-700 hover:bg-red-50 hover:text-red-700 transition"
>
  🚪 Cerrar sesión
</button>

          {/* Panel móvil */}
          {mobileOpen && (
            <div
              className="absolute right-4 top-[calc(100%+8px)] w-64
                         bg-[#03192f] text-white border border-[#EAB308]
                         rounded-xl shadow-lg z-50 p-4 animate-[fadeIn_.25s_ease-out]"
              style={{
                animationName: 'fadeIn',
                animationDuration: '.25s',
                animationTimingFunction: 'ease-out',
              }}
            >
              <style>{`
                @keyframes fadeIn {
                  from { opacity: 0; transform: translateY(-8px); }
                  to { opacity: 1; transform: translateY(0); }
                }
              `}</style>
              <h3 className="font-bold text-[#EAB308] border-b pb-2 mb-2">Menú</h3>
              {navItems.map((item) => (
                <button
                  key={item.to}
                  onClick={() => go(item.to)}
                  className="w-full text-left py-2 rounded transition-all
                             hover:text-[#EAB308] hover:bg-white/10"
                >
                  {item.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </header>

      {/* Empuje para no tapar contenido */}
      <div className="h-16 md:h-16" />
    </>
  );
};

export default Sidebar;
